import React from "react";
import PreHeaderBar from "web/react/components/app-header/pre-header-bar/pre-header-bar";
import HeaderBar from "web/react/components/app-header/header-bar/header-bar";
import { AppHeaderBarSerializer, AppPreHeaderBarSerializer } from "web/types/serializers";
import withReduxProvider from "web/react/redux-provider";
import { SetPaidSessionIdOnLinks } from "web/react/components/set-paid-session-id-on-links/set-paid-session-id-on-links";

import "./app-header.css";

interface AppHeaderProps {
    headerBar: AppHeaderBarSerializer;
    preHeaderBar: AppPreHeaderBarSerializer;
    labels: Record<string, any>;
}

function AppHeader({ headerBar, preHeaderBar, labels }: AppHeaderProps): React.ReactElement {
    return (
        <>
            <SetPaidSessionIdOnLinks />
            <PreHeaderBar
                accountDropdown={preHeaderBar.account_dropdown}
                accountText={preHeaderBar.account_text}
                accountUrl={preHeaderBar.account_url}
                countryInfo={preHeaderBar.country_info}
                languageSelector={preHeaderBar.language_selector}
                registerUrl={preHeaderBar.register_url}
                showCountryPicker={preHeaderBar.show_country_picker}
            />
            <HeaderBar
                labels={labels}
                cartButton={headerBar.cart_button}
                genders={headerBar.genders}
                homeUrl={headerBar.home_url}
                isAuthenticated={headerBar.is_authenticated}
                absoluteActionUrl={headerBar.absolute_action_url}
                absoluteHomeUrl={headerBar.absolute_home_url}
                mySearchesUrl={headerBar.my_searches_url}
                notificationsCount={headerBar.notifications_count}
                notificationsUrl={headerBar.notifications_url}
                savedItemUrl={headerBar.saved_item_url}
                searchInput={headerBar.search_input}
                userDropdown={{
                    accountDropdown: preHeaderBar.account_dropdown,
                    accountText: preHeaderBar.account_text,
                    accountUrl: preHeaderBar.account_url,
                    registerUrl: preHeaderBar.register_url,
                }}
            />
            {/* empty div used for header-bar-search React portal */}
            <div id="app-header-search-bar-mobile" className="hidden-desktop" />
        </>
    );
}

export default withReduxProvider(AppHeader);
